export default {"src":"/_next/static/media/Cooper-Ray2.6f8a3691.JPG","height":508,"width":762};